// extracted by mini-css-extract-plugin
export default {"container":"CollectionPointsTable_container__g2Jz8"};